export default __webpack_public_path__ + "static/media/completed_female@2x.a2305032.png";